import React, { useCallback } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import kebabCase from 'lodash/kebabCase';
import startCase from 'lodash/startCase';

// HOOKS
import { useLogContext } from '../helpers/logContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// LOCAL PARTS
import LogPill from './LogPill';

// STYLES
import styles from '../logs.module.scss';

// MAIN COMPONENT
const LogTab = ({
  name,
  label = startCase(name),
  icon = kebabCase(name),
  pill: Pill = LogPill,
}) => {

  // HOOKS
  const { activeLog, setActiveLog } = useLogContext();

  // CALLBACKS
  const handleClick = useCallback(
    () => setActiveLog(activeLog === name ? undefined : name),
    [name, activeLog, setActiveLog]
  )

  // RENDER
  return (
    <Button
      className={clsx(
        styles.tab,
        name === activeLog && ['active', styles.active]
      )}
      variant="custom"
      label={<>
        <span>{label}</span>
        {!!Pill ? <Pill name={name} /> : null}
      </>}
      icon={{
        className: styles.icon,
        use: icon,
        order: 1
      }}
      onClick={handleClick}
      justify="center"
    />
  );
}

// EXPORT
export default LogTab;
